import React from 'react';
import { Field } from 'formik';
import classNames from 'classnames';
import { LabelStyle, AbbrStyle, InputStyle } from './checkboxGroup.style';

// Input feedback
const InputFeedback = ({ error }) => (error ? <div className={classNames('input-feedback')}>{error}</div> : null);

const Checkbox = ({
	name,
	value,
	checked,
	onChange,
	id,
	label,
	className,
	isCrepdec,
	aroundAlign,
	...props
}) => (
	<div className={`form-check ${className}`}>
		<InputStyle
			styleInput={props.styleInput}
			name={name}
			id={id}
			type='checkbox'
			className='form-check-input'
			value={value}
			checked={checked}
			onChange={onChange}
		/>
		<LabelStyle isCrepdec={isCrepdec} classname={`form-check-label ${className}`} htmlFor={id}>
			{props.styleInput && (
				<AbbrStyle title={label}>{label}</AbbrStyle>
			)}
			{!props.styleInput && (
				<AbbrStyle title={label}>&#8226; {label}</AbbrStyle>
			)}
		</LabelStyle>
	</div>
);

class CheckboxGroup extends React.Component {
	getKey = () => (this.props.valueid ? this.props.valueid : 'id');

	getDisplayName = () => (this.props.displayName ? this.props.displayName : 'nome');

	getPropName = () => this.props.name;

	getVerificaCheckBox = () => this.props.isVerificaValores;

	handleChange = (event) => {
		const target = event.currentTarget;
		if (this.props.value) {
			const valueArray = [...this.props.value] || [];
			const validaCheckBox = this.getVerificaCheckBox();

			const key = this.getKey();

			// eslint-disable-next-line
			let item = this.props.values.find(c => c[key] == target.value);
			// eslint-disable-next-line
			let indexItem = valueArray.findIndex(c => c[key] == item[key]);

			if (indexItem === -1) {
				if (validaCheckBox) {
					if (item.id === 3 && valueArray.length > 0) {
						valueArray.length = 0;
					} else if (valueArray.length > 0) {
						const isItem = valueArray.find(c => c[key] === 3);
						if (isItem) {
							valueArray.splice(isItem, 1);
						}
					}
				}
				valueArray.push(item);
			} else {
				valueArray.splice(indexItem, 1);
			}

			if (this.props.setFieldValue) {
				this.props.setFieldValue(this.props.name, valueArray);
			}

			if (this.props.handleChangeCheckboxGroup) {
				this.props.handleChangeCheckboxGroup(valueArray);
			}
		}
	};

	checked = (value, item) => {
		if (value) {
			// eslint-disable-next-line
			return value.some(x => x[this.getKey()] == item[this.getKey()]);
		}
	};

	render() {
		const {
			value, values, error, touched, styleInput, isCrepdec, aroundAlign, className,
		} = this.props;

		return (
			<div className={aroundAlign ? 'row d-flex justify-content-around' : 'row container'}>
				{values.map((item, index) => (
					<div key={index} className={isCrepdec ? 'col-md-12 col-lg-8 col-xl-6 pl-0' : 'col-md-6 col-xl-4 pl-0'}>
						<div>
							<Field
								name={item.nome}
								aroundAlign={aroundAlign}
								isCrepdec={isCrepdec}
								styleInput={styleInput}
								key={index}
								component={Checkbox}
								id={`${this.getPropName()}.checkbox.${index}`}
								value={item[this.getKey()]}
								onChange={this.handleChange}
								checked={this.checked(value, item)}
								label={item[this.getDisplayName()]}
								className={className}
							/>
						</div>
					</div>
				))}
				{touched && <InputFeedback error={error} />}
			</div>
		);
	}
}

export default CheckboxGroup;
